import { render, staticRenderFns } from "./AssignmentsCard.vue?vue&type=template&id=3ce07767&scoped=true"
import script from "./AssignmentsCard.vue?vue&type=script&lang=js"
export * from "./AssignmentsCard.vue?vue&type=script&lang=js"
import style0 from "./AssignmentsCard.vue?vue&type=style&index=0&id=3ce07767&prod&lang=scss&scoped=true"
import style1 from "./AssignmentsCard.vue?vue&type=style&index=1&id=3ce07767&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce07767",
  null
  
)

export default component.exports
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinner,QIcon,QSelect,QItem,QField});
